import { ApiEndpoint } from 'controller/endpoint'

export const getCollectionKey = ({ id, language }: { id: string; language: string }) =>
  `${ApiEndpoint.collection.details(id)}/${language}`
